import React from "react";
import BreadcrumbList from "../../shared/breadcrumb-list";
import { appUrl } from "../../../constants/url-constants";

const SFLandingPageBreadcrumb = () => {
    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            window.location.href = `${appUrl()}/`;
        } else {
            window.location.href = `${appUrl()}${item.redirectURL}`;
        }
    };

    const computeBreadcrumbList = () => {
        const list = [
            {
                displayText: `Loan Against Car`,
                redirectURL: "/loan-against-car/"
            }
        ];
        return list;
    };

    return (
        <div className="cvh">
            <BreadcrumbList
                homeText={"Home"}
                isRevamped={true}
                attachSchema={true}
                onClickCallback={onBreadcrumbClick}
                list={computeBreadcrumbList()}
            />
        </div>
    );
};

export default SFLandingPageBreadcrumb;
